module.exports = __webpack_public_path__ + "img/table.5fde2a24.png";